import { ui, define, s } from '@owenscorning/pcb.alpha';

import { Renderer } from './SpecificationsAndLiterature';
import { highlightSettingsSection } from '../../../../OC/PageBuilder/utilities/shared';

const StandardsAndDocuments = define`Standards and Documents`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/Placeholder`,
  view: ({ value }) => {
    const documents = JSON.stringify(Board.settings?.documents);
    const additionalDocuments = JSON.stringify(Board.settings?.additionalDocuments);

    return (
      <Renderer
        attributesAsPrependedAccordion={value.standardsAccordionTitle || 'Applicable Standards'}
        containerSize={value.containerSize}
        copy={value.copy}
        flattenToSingleAccordion={value.documentsAccordionTitle || 'Technical Documents'}
        reRender={[documents, additionalDocuments].filter(Boolean).join('')}
      />
    );
  },
  edit: {
    standardsAccordionTitle: ui`Text`({ label: 'Standards Accordion Title', default: 'Applicable Standards' }),
    documentsAccordionTitle: ui`Text`({ label: 'Documents Accordion Title', default: 'Technical Documents' }),
    [s._]: ui`Tip`.of('Please configure documents within the Documents section in Settings')({ noTopMargin: true }),
    [s._]: ui`RawLink`.of('Go to settings')({
      onClick: () => {
        highlightSettingsSection('sidebar-pane', 'productDocuments');
        Board?.setDocumentsOpener(true);
      },
      noTopMargin: true,
      icon: 'external-link',
    }),
  },
});

export default StandardsAndDocuments;
